import React, {useCallback, useEffect, useState} from "react";
import {Button, Input, Modal} from "antd";
import {deleteYIdPw, getYIdPw, getYToken, saveYIdPw, saveYToken, yogiyoLogin} from "../../api/api";
import {useDispatch, useSelector} from "react-redux";
import {switchFlag, yWebsockDisconnected} from "../../actions/yWebsockAction";
import {addWaitingOrder} from "../../actions/posAction";
import {reactLocalStorage} from "reactjs-localstorage";
import Const from "../../const";
import {modalStyle} from "../../lib/util/codeUtil";

const YogiyoSetting = () => {
    const loginInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    const yWebsockIsConnected = useSelector(state => state.yWebsock.isConnected);

    const dispatch = useDispatch();

    const [inputs, setInputs] = useState({yId: null, yPw: null});
    const [yToken, setYToken] = useState(null);

    const onChange = useCallback(e => {
        const {name, value} = e.target;
        setInputs({
            ...inputs,
            [name]: value
        })
        console.log(inputs);
    }, [inputs]);

    const onClickYIdPwButton = () => {
        if (yWebsockIsConnected) onAlreadyAccepted();
        else onNotAccepted();
    }

    const onAlreadyAccepted = async () => {
        Modal.confirm({
            title: "재접속 요청",
            content: "이미 접속 완료된 상태입니다. 재접속을 시도하시겠습니까?",
            ...modalStyle,
            onOk: async () => {
                onNotAccepted();
            }
        });
    }

    const onNotAccepted = () => {
        Modal.confirm({
            title: "로그인",
            content: `${inputs?.yId} 로 접속 하시겠습니까?`,
            ...modalStyle,
            onOk: async () => {
                // 조회된 yId/yPw로 요기요 로그인 (yToken 발급)
                const yogiyoLoginRes = await yogiyoLogin({username: inputs.yId, password: inputs.yPw});
                if (yogiyoLoginRes && yogiyoLoginRes.token) {
                    setYToken(yogiyoLoginRes.token);

                    const reqData = {
                        branchIdx: loginInfo?.branchIdx,
                        frId: loginInfo?.id,
                    };

                    // 발급받은 token yToken으로 저장
                    await saveYToken({
                        ...reqData,
                        ...yogiyoLoginRes,
                    });

                    const res = await saveYIdPw({
                        branchIdx: loginInfo?.branchIdx,
                        frName: loginInfo?.frName,
                        frId: loginInfo?.id,
                        frIdx: loginInfo?.idx,
                        ...inputs
                    });

                    dispatch(switchFlag());

                    if (null == res) Modal.warn({
                        title: "저장 실패",
                        content: "서버 오류로 인해 저장에 실패했습니다.",
                        ...modalStyle,
                    });
                    else {
                        if (res.result === 'success') Modal.info({
                            title: "저장 성공",
                            content: "저장에 성공했습니다.",
                            ...modalStyle,
                        });
                        else Modal.warn({
                            title: "저장 실패",
                            content: "저장에 실패했습니다.",
                            ...modalStyle,
                        });
                    }
                } else {
                    Modal.warn({
                        title: "접속 실패",
                        content: "잘못된 아이디/비밀번호 입니다.",
                        ...modalStyle,
                    });
                }
            }
        })
    }

    const onDeleteYId = async () => {
        if (!yWebsockIsConnected) {
            Modal.warn({
                title:'y연동설정 해제 실패',
                content: "현재 연동설정이 되어 있지 않습니다.",
                ...modalStyle,
            })
            return;
        }
        Modal.confirm({
            title:"y연동설정 해제",
            content:"y연동설정을 해제하시겠습니까? 저장된 yId/yPw가 삭제됩니다.",
            ...modalStyle,
            onOk: async () => {
                try {
                    const reqData = {
                        branchIdx: loginInfo?.branchIdx,
                        frId: loginInfo?.id,
                    };

                    const res = await deleteYIdPw(reqData);
                    if (null === res || res.result !== 'success') {
                        Modal.warn({
                            title: "연동해제 실패",
                            content: "연동해제에 실패했습니다.",
                            ...modalStyle,
                        })
                    } else {
                        Modal.info({
                            title:"연동해제 성공",
                            content:"연동해제에 성공했습니다.",
                            ...modalStyle,
                        })
                        if (null !== global.yWs) {
                            global.yWs.close();
                            global.yWs = null;
                        }
                        dispatch(yWebsockDisconnected());
                    }
                } catch (e) {
                    Modal.warn({
                        title: "연동해제 실패",
                        content: "연동해제에 실패했습니다.",
                        ...modalStyle,
                    })
                }
            }
        })
    }

    useEffect(async () => {
        // 기존에 저장된 yToken 있는지 조회
        const reqData = {
            branchIdx: loginInfo?.branchIdx,
            frId: loginInfo?.id,
        };

        const tokenRes = await getYToken(reqData);
        if (tokenRes.token) {
            setYToken(tokenRes.token);
            return;
        }

        // 기존에 저장된 yToken 없을 시 저장된 yId/yPw 있는지 조회
        const res = await getYIdPw(reqData);
        if (res.value) setInputs(res.value);

        // 조회된 yId/yPw로 요기요 로그인 (yToken 발급)
        const yogiyoLoginRes = await yogiyoLogin({username: res.value.yId, password: res.value.yPw});
        if (yogiyoLoginRes) setYToken(yogiyoLoginRes.token);

        // 발급받은 token yToken으로 저장
        await saveYToken({
            ...reqData,
            ...yogiyoLoginRes,
        });

    }, []);

    return (<div className={'yogiyo-elem'}>
        <div className="yogiyo-title">
            yId/yPw 설정
            <br style={{height: 10}}/>
            <div>접속상태 : {yWebsockIsConnected ? <p style={{color: "green"}}>완료</p> : <p style={{color: "red"}}>실패</p>}</div>
        </div>
        <div className="yogiyo-wrap">
            <div className="yogiyo-input-label">yId</div>
            <Input autoComplete={"new-password"} name={"yId"} onChange={onChange} className={"yogiyo-input"}
                   placeholder={"yId를 입력해주세요."}/>
            <div className="yogiyo-input-label">yPw</div>
            <Input autoComplete={"new-password"} type={"password"} name={"yPw"} onChange={onChange} className={"yogiyo-input"}
                   placeholder={"yPw를 입력해주세요."}/>
            <Button onClick={() => onClickYIdPwButton()} type={"primary"} className={"yogiyo-button"}>저장</Button>
        </div>

        <div style={{marginTop:20}} className="yogiyo-title">
            연동설정 해제
            <Button style={{marginLeft:10}} onClick={async () => await onDeleteYId()}>연동설정 해제</Button>
        </div>
        </div>)
}

export default YogiyoSetting;
